module.exports = __webpack_public_path__ + "static/media/reset-color.0b3bd1f0.svg";